<script>
import isObject from 'lodash/isObject'
import WaitingText from '../Text/WaitingText.vue'
import ErrorText from '../Text/ErrorText.vue'
import SuccessText from '../Text/SuccessText.vue'
import { JSONError } from '../../../../../Errors/JsonError'

export default {
  components: { SuccessText, ErrorText, WaitingText },
  computed: {
    jsonStatus() {
      return this.$root.jsonStatus
    },

    jsonStatusText() {
      if ((!this.$root.jsonStatusText) instanceof JSONError) {
        return this.$root.jsonStatusText
      }

      const errorCode = this.$root.jsonStatusText?.response?.code
      if (!errorCode || !this.$te(errorCode)) {
        return this.$root.jsonStatusText
      }

      return this.$t(errorCode)
    },

    jsonStatusObject() {
      return this.$root.jsonStatusObject
    },

    errorsInjected() {
      return this.$root.errorsInjected
    },

    classModal() {
      switch (this.jsonStatus) {
        case 'success':
          return 'bg-pale-success'
        case 'error':
          return 'bg-pale-danger'
      }
      return 'bg-pale-info'
    },

    structuredErrors() {
      const formatErrors = (errors, field = []) => {
        if (Array.isArray(errors)) {
          if (errors[0]?.field && errors[0]?.message) {
            return errors
          }
          return errors.map((message) => ({
            field: field.join('.') || this.$t('main.generalError'),
            message,
          }))
        }

        if (!isObject(errors)) {
          return []
        }

        const errorsList = []
        for (const [section, sectionErrors] of Object.entries(errors)) {
          if (section === 'children') {
            for (const [childKey, childErrors] of Object.entries(sectionErrors)) {
              errorsList.push(...formatErrors(childErrors, Array.of(...field, childKey)))
            }
          } else if (section === 'errors') {
            errorsList.push(...errors.errors.map((message) => ({ field: field ? field.join('.') : 'errors', message })))
          } else if (section === 'details' && Array.isArray(sectionErrors)) {
            errorsList.push(
              ...sectionErrors.map((detail) => ({ field: detail.field, message: detail.title, isDetail: true })),
            )
          } else if (Array.isArray(sectionErrors)) {
            errorsList.push(...sectionErrors.map((message) => ({ field: section, message })))
          }
        }

        return errorsList
      }

      return formatErrors(this.jsonStatusObject)
    },
  },
  methods: {
    fieldLabel(name) {
      if (this.$te(`fields.${name}.label`)) {
        return this.$t(`fields.${name}.label`)
      }

      if (this.$te(name)) {
        return this.$t(name)
      }

      return name
    },
  },
  mounted: function () {
    //TODO: Replace by Teleport
    $('#' + this.id).appendTo('#appVue')
  },
}
</script>
<template>
  <div
    class="modal modal-center"
    id="modal-waiting-text"
    ref="modalWaitingText"
    tabindex="-1"
    role="dialog"
    style="z-index: 9999 !important"
  >
    <div class="modal-dialog" role="document">
      <div :class="'shadow-material-5 modal-content ' + classModal">
        <button
          style=""
          v-if="jsonStatus !== 'waiting'"
          type="button"
          class="close modal-close-btn"
          data-dismiss="modal"
          :title="$t('main.dismiss')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <WaitingText v-if="jsonStatus === 'waiting'" class-spinner="text-center fs-18 p-40">
            <span v-html="jsonStatusText"></span>
          </WaitingText>
          <div v-if="jsonStatus === 'info'" class="text-center justify-content-center">
            <div class="media flex-column align-items-center">
              <span class="fw-500" v-html="jsonStatusText"></span>
            </div>
          </div>
          <ErrorText v-if="jsonStatus === 'error'">
            <span v-html="jsonStatusText"></span>
            <ul>
              <li v-for="(error, index) in structuredErrors" :key="index">
                <template v-if="error.isDetail"> {{ fieldLabel(error.field) }} : {{ error.message }} </template>
                <template v-else>
                  {{ fieldLabel(error.field) !== error.field ? fieldLabel(error.field) + ' : ' : ''
                  }}{{ error.message }}
                </template>
              </li>
            </ul>
            <ul>
              <li v-for="error in errorsInjected">
                {{ error }}
              </li>
            </ul>
          </ErrorText>
          <SuccessText v-if="jsonStatus === 'success'">
            <span v-html="jsonStatusText"></span>
          </SuccessText>
        </div>
      </div>
    </div>
  </div>
</template>
